import api, {graphqlQueryBuild} from '.';

export const loadLivesAsync = async locale => {
    let query = graphqlQueryBuild(
        'live',
        'id title description image url needFilter',
    );
    try {
        let response = await api.get('', {
            params: {
                query,
            },
        });

        if (response.data.data.live) {
            return response.data.data.live;
        }
        throw new Error('Lives load failed');
    } catch (error) {
        throw new Error('Lives load failed');
    }
};
